var map = {
	"./labmemtest_text_nextbtn_en.png": "d83e",
	"./labmemtest_text_nextbtn_jp.png": "3dc7",
	"./labmemtest_text_nextbtn_kr.png": "1c44",
	"./labmemtest_text_nextbtn_sc.png": "ded3",
	"./labmemtest_text_nextbtn_tc.png": "b5d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4c7";